import { Affix, Upload, Spin, Modal, Row, Col, Button, TreeSelect, Popconfirm, Card, Input, Select, Checkbox, Switch, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import axios from 'axios';
import dayjs from 'dayjs';
import AdminModal from "../AdminModal";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const AdminFileModal = (props) => {
    const [tag_data, set_tag_data] = useState([]);
    const [folder_data, set_folder_data] = useState([]);
    const [file_name, set_file_name] = useState('');
    const [file_extension, set_file_extension] = useState('');
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    // useEffect(() => {
    //     console.log(props.editcard)
    // }, [props.editcard])
    useEffect(() => {
        // console.log(props.editcard['file_client_name'])
        if (props.editcard['file_client_name'] != undefined) {
            let str = props.editcard['file_client_name'].split('.');
            let file_extension_tmp = `.${str.at(-1)}`;
            let file_client_name_tmp = props.editcard['file_client_name'].replace(file_extension_tmp, '');
            // console.log(str);
            // console.log(file_extension_tmp);
            // console.log(file_client_name_tmp);
            set_file_name(file_client_name_tmp)
            set_file_extension(file_extension_tmp);
        }
    }, [props.editcard['file_client_name']])
    useEffect(() => {
        axios
            .get('/component/classify/type/folder', { params: { classify_structure_id: 1, classify_structure_type_id: 0 } })
            .then((response) => {
                set_folder_data(response.data.data)
            })
        get_tag();
    }, [])
    const get_tag = () => {
        axios
            .get('/component/classify/media/hashtag')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((item, i) => {
                    let data_json = {};
                    data_json['label'] = item.tag_name;
                    data_json['value'] = item.tag_id;
                    data_tmp.push(data_json);
                })
                set_tag_data(data_tmp)
            })
    }
    return (
        <>
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{
                        backgroundColor: '#faf6f5',
                        borderTop: `solid #${props.color} 5px `,
                        padding: '20px',
                        position: 'relative',
                        position: 'relative', height: '80vh'
                    }}>
                        <Row gutter={[10, 10]} justify='center' style={{ minHeight: '65vh', maxHeight: '65vh', overflowY: 'scroll' }}>
                            {/* <Spin tip="Loading" size="large" spinning={props.loading}> */}
                            <Col span={24} >
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={24}>
                                        <Row justify="space-between" style={{ position: 'relative' }} align={'bottom'}>
                                            {props.edit ?
                                                <>
                                                    <img width="35%" height="35%" src='/cram_school/edit.png'></img>
                                                </> :
                                                <>
                                                    <img width="35%" height="35%" src='/cram_school/add.png'></img>
                                                </>}
                                            <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >修改檔案</Col>
                                            {props.edit ? <>
                                                <Col>
                                                    <Popconfirm
                                                        placement="topRight"
                                                        title='確定刪除嗎？'
                                                        onConfirm={e => props.handleDelete(props.editcard['file_id'])}
                                                        okText="確定"
                                                        cancelText="取消"
                                                    >
                                                        <Button style={{ backgroundColor: '#FCF5F6' }} >
                                                            <Row>
                                                                <Col span={6}>
                                                                    <img width="80%" src='/cram_school/trashicon.png'></img>
                                                                </Col>
                                                                <Col span={18}>
                                                                    <span>刪除檔案</span>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                    </Popconfirm>
                                                </Col>
                                            </> : null}
                                        </Row>
                                    </Col>
                                    <Col span={6}>檔案名稱</Col>
                                    <Col span={12}>
                                        <Input placeholder={'請輸入檔案名稱'} value={file_name}
                                            // onChange={e => props.setEditCard(prev => {
                                            //     return (
                                            //         {
                                            //             ...prev,
                                            //             file_client_name: `${e.target.value}.${file_extension}`,
                                            //         }
                                            //     )
                                            // })}
                                            onChange={e => set_file_name(e.target.value)}
                                            autoComplete="off" />
                                    </Col>
                                    <Col span={6}>{file_extension}</Col>
                                    {props.tag != false ? <>
                                        <Col span={6}>hashtag</Col>
                                        <Col span={18}>
                                            <Select
                                                mode="multiple"
                                                allowClear
                                                style={{
                                                    width: 250,
                                                }}
                                                labelInValue
                                                placeholder="請選擇hashtag"
                                                value={(props.editcard?.['tag_name'] || []).length != 0 ? props.editcard?.['tag_id'].map((value) => value) : []}
                                                onChange={value => props.setEditCard((pre) => {
                                                    return (
                                                        {
                                                            ...pre,
                                                            tag_id: value.map((tmp) => tmp.value),
                                                            tag_name: value.map((tmp) => tmp.label),
                                                        }
                                                    )
                                                })}
                                                options={tag_data}
                                            />
                                        </Col>
                                    </> : null}
                                    <Col span={8}>將檔案移至</Col>
                                    <Col span={16}>
                                        <TreeSelect
                                            style={{
                                                width: "100%",
                                            }}
                                            allowClear
                                            treeDefaultExpandAll
                                            // value={form_data['learn_english_year_id'] || value.placeholder}
                                            onChange={(newValue) => props.setEditCard(pre => {
                                                return ({
                                                    ...pre,
                                                    'classify_structure_type_parent_id': newValue,
                                                    // 'learn_english_year_name': value.label,
                                                })
                                            })}
                                            treeData={folder_data}
                                        />
                                    </Col>
                                    {/* {props.file_type == 'doc' ? <>
                                            <Col span={24} >
                                                <JoditEditor
                                                    ref={editor}
                                                    value={props.editcard['content']}
                                                    config={config}
                                                    tabIndex={1} // tabIndex of textarea
                                                    onBlur={(content) => {
                                                        props.setEditCard(prev => {
                                                            return (
                                                                {
                                                                    ...prev,
                                                                    content: content,
                                                                }
                                                            )
                                                        })
                                                    }} // preferred to use only this option to update the content for performance reasons
                                                    height={500}
                                                    allowResizeX={true}
                                                    allowResizeY={true}
                                                />
                                            </Col>
                                        </> : null} */}
                                </Row>
                            </Col>
                            {/* </Spin> */}

                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => props.handleEdit(`${file_name}${file_extension}`)}
                                            size='large' style={{ background: '#f09a45', color: '#ffffff' }} block
                                        >修改</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </>}
                centered
            ></Modal >
        </>)
}
export default AdminFileModal;